<template>
  <el-dialog :title="$t('importAccount.title')" :visible.sync="visible" width="550px" @close="resetForm">
    <el-form label-width="100px" class="text-left">
      <el-form-item :label="$t('importAccount.accountType')">
        <el-select v-model="acctType" style="width: 100%" @change="onAcctTypeChange">
          <el-option v-for="t in acctTypeOptions" :key="t.value" :label="t.label" :value="t.value" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('importAccount.selectFile')">
        <el-upload class="upload-demo" action="" :on-change="handleFileChange" :auto-upload="false"
          :show-file-list="false" accept=".xlsx,.xls">
          <el-button size="small" type="primary">{{ $t('importAccount.selectFile') }}</el-button>
          <div slot="tip" class="el-upload__tip">
            {{ fileName || $t('importAccount.fileRequired') }}
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item :label="$t('importAccount.downloadTemplate')">
        <div>
          <span>{{ $t('importAccount.downloadFirst') }}</span>
          <el-link type="primary" @click="downloadTemplate">
            {{ $t('importAccount.importTemplate') }}
          </el-link>
          <span>{{ $t('importAccount.prepareData') }}</span>
        </div>
        <div class="template-desc">
          <span class="desc-text">{{ currentDesc }}</span>
        </div>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="importData" :loading="loading">
        {{ $t('importAccount.import') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { importAccountPrestore, downloadAccountTemplate, getDict } from '@/api/account/accountManageApi'

export default {
  name: 'ImportAccount',
  data() {
    return {
      visible: false,
      loading: false,
      downloading: false,
      file: null,
      fileName: '',
      acctType: '2003',
      acctTypeOptions: []
    }
  },
  computed: {
    currentDesc() {
      const descMap = {
        '2003': this.$t('importAccount.importDesc'),
        '2004': this.$t('importAccount.importDesc2004'),
        '2005': this.$t('importAccount.importDesc2005'),
        '2006': this.$t('importAccount.importDesc2006')
      }
      return descMap[this.acctType] || this.$t('importAccount.importDesc')
    }
  },
  methods: {
    async loadAcctTypes() {
      try {
        const data = await getDict('account', 'acct_type')
        this.acctTypeOptions = data.map(item => ({
          value: item.statusCd,
          label: item.name
        }))
      } catch (e) {
        this.acctTypeOptions = [
          { value: '2003', label: '通用账户' },
          { value: '2004', label: '物业费扣款账户' },
          { value: '2005', label: '水电费扣款账户' },
          { value: '2006', label: '公摊费扣款账户' }
        ]
      }
    },

    onAcctTypeChange() {
      // 切换账户类型时清空已选文件
      this.file = null
      this.fileName = ''
    },

    async downloadTemplate() {
      if (this.downloading) return
      this.downloading = true
      try {
        await downloadAccountTemplate({ acctType: this.acctType })
        this.$message.success(this.$t('importAccount.downloadSuccess') || '模板下载成功')
      } catch (error) {
        console.error('下载模板失败', error)
        this.$message.error(this.$t('importAccount.downloadFail') || '模板下载失败')
      } finally {
        this.downloading = false
      }
    },

    open() {
      this.visible = true
      this.loadAcctTypes()
    },

    handleFileChange(file) {
      this.file = file.raw
      this.fileName = file.name
    },

    async importData() {
      if (!this.file) {
        this.$message.warning(this.$t('importAccount.fileRequired'))
        return
      }

      const ext = this.fileName.split('.').pop().toLowerCase()
      if (!['xlsx', 'xls'].includes(ext)) {
        this.$message.warning(this.$t('importAccount.invalidExcel'))
        return
      }

      if (this.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('importAccount.fileSizeExceed'))
        return
      }

      this.loading = true
      try {
        const formData = new FormData()
        formData.append('uploadFile', this.file)
        formData.append('acctType', this.acctType)
        const result = await importAccountPrestore(formData)
        const msg = this.$t('importAccount.importResult')
          .replace('{total}', result.total || 0)
          .replace('{success}', result.success || 0)
          .replace('{fail}', result.fail || 0)
        if (result.fail > 0) {
          this.$message.warning(msg)
        } else {
          this.$message.success(msg)
        }
        this.$emit('success')
        this.visible = false
      } catch (error) {
        console.error('import failed:', error)
        this.$message.error(error.message || error)
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.file = null
      this.fileName = ''
    }
  }
}
</script>

<style scoped>
.template-desc { margin-top: 5px; }
.desc-text { color: #909399; font-size: 12px; }
</style>
